export const numberToshortString = (n: number, digits: number = 2): string => {
  if (n > 1e9)
    return n % 1e9 > 0 ? `${(n / 1e9).toFixed(digits)}b` : `${n / 1e9}b`;
  if (n > 1e6)
    return n % 1e6 > 0 ? `${(n / 1e6).toFixed(digits)}m` : `${n / 1e6}m`;
  if (n > 1e3)
    return n % 1e3 > 0 ? `${(n / 1e3).toFixed(digits)}k` : `${n / 1e3}k`;

  return n.toString();
};
